import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useFavorites } from '../context/FavoritesContext';
import './Header.css';

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { lang, toggleLang, t } = useLanguage();
  const { favorites } = useFavorites();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // If we're not on home, navigate first and pass the target section
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
      setMenuOpen(false);
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  const scrollToFavorites = () => {
    if (favorites.length === 0) return;
    // Scroll to works section and the favorited items will be visible
    scrollToSection('works');
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-logo" data-testid="header-logo" onClick={() => { if (location.pathname !== '/') navigate('/'); else window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <span className="logo-text">C. LLAGUNO</span>
        </div>

        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          <button className="nav-link" data-testid="nav-works" onClick={() => scrollToSection('works')}>{t('nav_works')}</button>
          <button className="nav-link" data-testid="nav-sculptures" onClick={() => scrollToSection('sculptures')}>{t('nav_sculptures')}</button>
          <button className="nav-link" data-testid="nav-about" onClick={() => scrollToSection('about')}>{t('nav_about')}</button>
          <button className="nav-link" data-testid="nav-contact" onClick={() => scrollToSection('contact')}>{t('nav_contact')}</button>
          <button 
            className="header-fav-btn" 
            onClick={scrollToFavorites}
            aria-label="Favorites"
            data-testid="header-favorites"
          >
            <Heart size={18} fill={favorites.length > 0 ? '#000' : 'none'} />
            {favorites.length > 0 && (
              <span className="header-fav-count">{favorites.length}</span>
            )}
          </button>
          <button className="lang-toggle" onClick={toggleLang} data-testid="lang-toggle">
            {lang === 'en' ? 'ES' : 'EN'}
          </button>
        </nav>

        <button 
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${menuOpen ? 'open' : ''}`}></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
